import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { PaginatedResponse } from "@/queries/types";
import { promptLabel } from "@/schemas";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

export const usePromptLabels = ({
  userToken,
  workspace_id,
  prompt_id,
  page,
  enabled = true,
}: {
  userToken: string;
  workspace_id: number;
  prompt_id?: number;
  page?: number;
  enabled?: boolean;
}) =>
  useQuery<PaginatedResponse<promptLabel.Response[], "prompt_labels", string>>(
    [ENDPOINTS.prompt_labels(workspace_id), userToken, workspace_id, prompt_id, page],
    () => {
      const url = new URL(ENDPOINTS.prompt_labels(workspace_id));
      url.searchParams.set("workspace_id", workspace_id.toString());
      if (prompt_id) {
        url.searchParams.set("prompt_id", prompt_id.toString());
      }
      url.searchParams.set("per_page", "50");
      if (page) {
        url.searchParams.set("page", page.toString());
      }
      return fetch(url, {
        headers: authHeader(userToken),
      }).then(handleResponse);
    },
    {
      enabled,
    },
  );
